import { render, staticRenderFns } from "./Year24.vue?vue&type=template&id=0419913e"
import script from "./Year24.vue?vue&type=script&lang=js"
export * from "./Year24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports